module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2b0b532fda25919c2ea7ff2129ae9271.png";